
import wx from 'weixin-js-sdk'
import cmFooter from '@/components/cmFooter.vue'
import Countup from 'vux/src/components/countup/index.vue'

export default {
name: 'user',
components:{
wx,cmFooter,Countup
},
data () {
return {
code:'',
grade:0,
info: {
nickname:'未登录',
head:'/static/images/head.png',
other_title:'',
address:'',
},
order:{
total_rebate:0.00,
month_rebate:0.00,
today_rebate:0.00,
last_month_rebate:0.00,
total_order:0,
month_order:0,
last_month_order:0,
today_order:0,
today_collect:0,
month_collect:0,
last_month_collect:0,
total_collect:0,
clean_today_order:0,
clean_month_order:0,
clean_last_month_order:0,
clean_total_order:0,
product_today_order:0,
product_month_order:0,
product_total_order:0,
product_last_month_order:0,
today_card:0,
total_card:0,
month_card:0,
last_month_card:0,
todayInFactory:0,
monthInFactory:0,
lastMonthInFactory:0,
totalInFactory:0,
todayOutFactory:0,
monthOutFactory:0,
lastMonthOutFactory:0,
totalOutFactory:0,
},
service:{},
node:[],
}
},
created(){
if(this.$func.getLocal('token')){
this.getInfo();
}else{
this.$router.push({path:'/login'})
}
},
mounted(){

},
methods:{






























getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
if(!Number(res.data.cid)){
this.$router.push({path:'/login'})
return false;
}
this.info = res.data;
this.grade = res.data.grade;
this.$func.setLocal('token',res.data.token);
this.$func.setLocal('grade',res.data.grade);

this.groupRebate();
}
})
},
edit(){
this.$router.push({path:'/editUser'})
},
groupRebate(){
this.$api.groupRebate({}).then((res)=>{
if(res){
this.order = res.data.order;
this.service = res.data.service;
}
})
},
qrcode(){
let _this = this;
this.$api.qrcode({}).then((res)=>{
if(res){
console.log(res);
wx.previewImage({
current:res.data.path,
urls:[res.data.path]
});
}
})
},
out(){
this.$func.confirm('确认退出账号？','温馨提示',()=>{
this.$api.out({}).then((res)=>{
this.$func.setLocal('node_v1','');
this.$func.setLocal('grade','');
this.$func.setLocal('token','');
this.$func.setLocal('channel','');


this.$router.push({path:'/login'})
})
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/user.vue